<script setup>
import _ from 'lodash'
import {
  useConfigStore,
} from '@core/stores/config'
import {
  AppContentLayoutNav,
} from '@layouts/enums'
import {
  switchToVerticalNavOnLtOverlayNavBreakpoint,
} from '@layouts/utils'

const DefaultLayoutWithHorizontalNav = defineAsyncComponent(() => import(
  './components/DefaultLayoutWithHorizontalNav.vue'))

const DefaultLayoutWithVerticalNav = defineAsyncComponent(() => import(
  './components/DefaultLayoutWithVerticalNav.vue'))

const configStore = useConfigStore()
import SiteMessage from '@/components/share/message.vue'
import LoginPopupReminder from '@/components/dialog/login-popup-reminder.vue'

// ℹ️ This will switch to vertical nav when define breakpoint is reached when in horizontal nav layout

// Remove below composable usage if you are not using horizontal nav layout in your app
switchToVerticalNavOnLtOverlayNavBreakpoint()

const {
  layoutAttrs,
  injectSkinClasses,
} = useSkins()

injectSkinClasses()

const preLoaded = useState('preLoaded')
const userInfo = useState('auth.user.info')

// --------------- 👉 User Pinia Store
import {
  useStore,
} from '@/stores/user'

const userStore = useStore()

// --------------- 👉 User Pinia Store
const featureKeys = userStore.featureKeys
const roles = userStore.roles


async function onLoad() {
  if (!userInfo.value) {
    const slug = localStorage.getItem('slug')

    useState(`slug`, () => slug)

    const router = useRouter()
    const from = encodeURIComponent(_.get(router, 'currentRoute.value.fullPath'))
    const accessToken = localStorage.getItem('access_token')

    navigateTo(accessToken ? `/redirect?from=${from}` : '/login', {
      replace: true,
    })
  }
}

// chagne the theme to light only
await onMounted(() => {
  configStore.theme = 'light'
  if(_.includes(roles, 'distributor_admin'))
    configStore.appContentLayoutNav = AppContentLayoutNav.Vertical
  onLoad()
})

// chagne the theme to light only
</script>

<template>
  <div>
    <ClientOnly>
      <SiteMessage />
    </ClientOnly>
    <LoginPopupReminder v-if="preLoaded && userInfo" />
    <Component
      v-bind="layoutAttrs"
      :is="configStore.appContentLayoutNav === AppContentLayoutNav.Vertical ? DefaultLayoutWithVerticalNav : DefaultLayoutWithHorizontalNav"
      v-if="preLoaded"
    >
      <slot />
    </Component>
  </div>
</template>

<style lang="scss">
    // As we are using `layouts` plugin we need its styles to be imported
    @use "@layouts/styles/default-layout";
</style>